/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import {
    IconFacebook,
    IconInstagram,
    IconLinkedin,
    IconThreads,
    IconTiktok,
    IconTwitter,
    IconWhatsapp,
    IconYoutube
} from '../../../assets';
import { BreakApart, capitalizeWords, formatSelects, isColorLight, removerAcentos } from '../../../utils/FunctionsGlobals';
import { appendCodsiteQuery } from '../../../utils/url';
// utils
import { useAuth } from '../../context/Info';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import Popular from '../populares/Popular';
import styles from './About1.module.css';

const AboutPieces1: React.FC<{
    site: any;
    allCities: any;
    allCitiesTipes?: any;
    origin?: any;
    codsite?: any;
    isMobile?: Boolean;
    favorito?: any;
    allRodape: any;
    pagina?: any;
    hidePopular?: boolean;
}> = ({ site, allCities, allCitiesTipes, origin, codsite: _codsite, isMobile, favorito, allRodape, pagina: _pagina, hidePopular }) => {
    const showLoftBadge = Number(site?.id) === 1898;
    const renderText = () => {
        return `/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?favoritos=${favorito}`;
    };
    const withCodsite = (href: string) => appendCodsiteQuery(href, _codsite, origin);
    const cor_fundo3 = (isColorLight(site?.cor3) && isColorLight(site?.cor7)) || (!isColorLight(site?.cor3) && !isColorLight(site?.cor7)) ? isColorLight(site?.cor3) ? site?.cor11 : site?.cor13 : site?.cor7;
    const cor_fundo6 = isColorLight(site?.cor6) ? site?.cor11 : site?.cor13;

    const {
        allDataHome,
    } = useAuth();
    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: IconInstagram,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.threads || '',
            id: 6,
            icon: IconThreads,
            rede: 'Threads'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: IconFacebook,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: IconTwitter,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: IconTiktok,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: IconYoutube,
            rede: 'Youtube'
        },
         {
            href: site?.Dados?.Linkedin || '',
            id: 7,
            icon: IconLinkedin,
            rede: 'Linkedin'
        },
    ];
    // useState
    const format = formatSelects(allCitiesTipes);
    const allTypes = BreakApart(format?.slice(0, 10), 10);
    const allRodape1 = allRodape;
    const host = origin;
    const validaEmpree = allRodape ? allRodape.some((imovel: { empreendimento: any; }) => imovel.empreendimento !== null) : false;
    const isNovember = new Date().getMonth() === 10;

    const footerFlags = [
        { code: 'us', label: 'EUA' },
        { code: 'jp', label: 'Japao' },
        { code: 'br', label: 'Brasil' },
        { code: 'ar', label: 'Argentina' },
        { code: 'cl', label: 'Chile' },
        { code: 'py', label: 'Paraguai' },
        { code: 'uy', label: 'Uruguai' },
    ];

    return (
        <>
            {site?.modelo_pesquisa_popular == 1 && !hidePopular && Number(site?.id) !== 2551 && <Popular site={site} allRodape={allRodape} codsite={_codsite} origin={origin}/>}
            {allSocials?.length > 0 ?
            <div className={styles.redes_sociais} style={site?.id == 2455 ? {backgroundColor: site?.cor3} : {backgroundColor: site?.cor6}}>
                <div className={styles.container1}>
                    {allSocials?.map((v) => {
                        if (v) {
                            if (v.href && site?.id != 2297) {
                                return (
                                    <a
                                        aria-label={v.href}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        href={v.href}
                                        onClick={async (e) => {
                                            e.preventDefault(); // Evita o redirecionamento automático

                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                            setTimeout(() => {
                                            window.open(
                                                v.href,
                                                "_blank"
                                            );
                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                        }}
                                        key={v.id}
                                        title={`Navegar para o ${v.rede} da imobiliária`}
                                        className={styles.adjust_img1}
                                    >
                                        {site?.id == 1630 || site?.id == 2346 ?
                                            v?.id == 3 ? <FaInstagram fill='white' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            v?.id == 1 ? <FaFacebook fill='white' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            v?.id == 2 ? <FaYoutube fill='white' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            v?.id == 4 ? <FaTwitter fill='white' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            <Image
                                                alt={`Imagem rede social ${v.rede}`}
                                                src={v.icon}
                                                height={37}
                                                width={37}
                                            />
                                        : site?.id == 2259 ?
                                            v?.id == 3 ? <FaInstagram fill='black' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            v?.id == 1 ? <FaFacebook fill='black' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            v?.id == 2 ? <FaYoutube fill='black' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            v?.id == 4 ? <FaTwitter fill='black' style={{display: "flex",alignItems: "center",fontSize: 24}}/> :
                                            <Image
                                                alt={`Imagem rede social ${v.rede}`}
                                                src={v.icon}
                                                height={37}
                                                width={37}
                                            />
                                        :
                                        <Image
                                            alt={`Imagem rede social ${v.rede}`}
                                            src={v.icon}
                                            height={37}
                                            width={37}
                                        />}

                                    </a>
                                );
                            }
                            return null;
                        }
                        return null;
                    })}

                    {site?.id == 2387 ?
                        <>
                            <a aria-label={"https://www.instagram.com/mauriciooliveira.imoveis/"}
                                target="_blank"
                                href={"https://www.instagram.com/mauriciooliveira.imoveis/"}
                                key={allSocials[0].id}
                                title={`Navegar para o Instagram de Mauricio de Oliveira`}
                                className={styles.adjust_img1}
                                style={{color: "rgb(255, 255, 255)",display: "grid",justifyItems: "center",fontWeight: 600}}
                               rel="noopener noreferrer">
                                <Image
                                    alt={`Imagem rede social Instagram`}
                                    src={allSocials[0].icon}
                                    height={37}
                                    width={37}
                                />
                                Mauricio de Oliveira
                            </a>
                            <a aria-label={"https://www.instagram.com/calebe.rolim?utm_source=ig_web_button_share_sheet&igsh=eHV5OTRvZmFkZDBs"}
                                rel="noopener noreferrer"
                                target="_blank"
                                href={"https://www.instagram.com/calebe.rolim?utm_source=ig_web_button_share_sheet&igsh=eHV5OTRvZmFkZDBs"}
                                key={allSocials[0].id}
                                title={`Navegar para o Instagram de Calebe Rolim`}
                                className={styles.adjust_img1}
                                style={{color: "rgb(255, 255, 255)",display: "grid",justifyItems: "center",fontWeight: 600}}
                            >
                                <Image
                                    alt={`Imagem rede social Instagram`}
                                    src={allSocials[0].icon}
                                    height={37}
                                    width={37}
                                />
                                Calebe Rolim
                            </a>
                        </>
                        : null}
                    {site?.id == "2485" &&
                        <a
                            rel="noopener noreferrer"
                            href="https://www.instagram.com/conect.consorcios?igsh=MTVzbXkxbmtxMnUzYw=="
                            target='_blank'
                            key={allSocials[0].id}
                            title={`Navegar para Instagram da imobiliária Conect Consorcios`}
                            className={styles.adjust_img1}
                        >
                            <Image
                                alt={`Imagem rede social Instagram`}
                                src={IconInstagram}
                                height={37}
                                width={37}
                            />
                        </a>
                    }
                    {site?.id == 2297 ?
                        <>
                            <a aria-label={"https://www.instagram.com/imoveis_deferrari?igsh=MWIzY3YyZTM4eGdjMg=="}
                                rel="noopener noreferrer"
                                target="_blank"
                                href={"https://www.instagram.com/imoveis_deferrari?igsh=MWIzY3YyZTM4eGdjMg=="}
                                key={allSocials[0].id}
                                title={`Navegar para o Instagram da imobiliária`}
                                className={styles.adjust_img1}
                                style={{color: "#4a4a4a",display: "grid",justifyItems: "center",fontWeight: 600}}
                            >
                                <Image
                                    alt={`Imagem rede social Instagram`}
                                    src={allSocials[0].icon}
                                    height={37}
                                    width={37}
                                />
                                RS
                            </a>
                            <a aria-label={"https://www.instagram.com/chaianedeferrari?igsh=MXUzbnE1cGpwYmo0NA=="}
                                rel="noopener noreferrer"
                                target="_blank"
                                href={"https://www.instagram.com/chaianedeferrari?igsh=MXUzbnE1cGpwYmo0NA=="}
                                key={allSocials[0].id}
                                title={`Navegar para o Instagram da imobiliária`}
                                className={styles.adjust_img1}
                                style={{color: "#4a4a4a",display: "grid",justifyItems: "center",fontWeight: 600}}
                            >
                                <Image
                                    alt={`Imagem rede social Instagram`}
                                    src={allSocials[0].icon}
                                    height={37}
                                    width={37}
                                />
                                SC
                            </a>
                        </>
                        : null}
                    {site?.id == "1836" &&
                        <a className={styles.blog} href="https://antigo.estilogramadoimoveis.com.br/blog" data-no-quicklink
                                data-no-instant
                                data-no-prefetch
                                rel="nofollow">
                            Blog
                        </a>
                    }
                </div>
            </div> : null}
            {(site?.id != 2034 || site?.id != 2231) &&
            <div
                className={styles.container}
                style={{backgroundColor: site?.cor3}}
            >
                {allCities?.length > 0 ? (
                    <div className={styles.divisao}>
                        <div className={styles.info_header} style={{color: cor_fundo3}}>IMÓVEIS POR CIDADE</div>
                        <ul className={styles.adjust_cities}>
                            {(allCities?.length > 0 ? allCities : [])
                                ?.slice(0, 10)
                                ?.map((v: any) => (
                                    v?.label ?
                                        <li className={styles.li_busca} key={v?.value} style={{color: cor_fundo3}}>
                                            <Link prefetch={false} href={withCodsite(`/imoveis/${site?.transacoes[0].toLowerCase()}/${removerAcentos(v?.label).toLowerCase()}/-/-/-`.replaceAll(
                                                        ' ',
                                                        '-'
                                                    ))} passHref>
                                                <div
                                                    title={"Imóveis em " + v?.label}
                                                    className={styles.info_body_cities}
                                                >
                                                    {v?.label}
                                                </div>
                                            </Link>
                                        </li>
                                    :null

                                ))}
                        </ul>
                    </div>
                ) : null}
                {allTypes?.length > 0 && site?.id != 2558 ?
                    <div className={styles.divisao}>
                        <div className={styles.info_header}  style={{color: cor_fundo3}}>IMÓVEIS POR TIPO</div>
                        <ul className={styles.adjust_cities}>
                            {allTypes[0]?.map((e: any) => (
                                <li className={styles.li_busca} key={e?.value} style={{color: cor_fundo3}}>
                                    <Link prefetch={false} href={withCodsite(`/imoveis/venda/-/-/-/${removerAcentos(e?.label?.replaceAll('-','002d').replaceAll(' ','-')).toLowerCase()}`)} passHref>
                                    <div
                                        className={styles.info_body_cities}
                                        title={`${e?.label} em ${site?.Dados?.cidade} e região`}

                                        key={e?.value}
                                    >
                                        {e?.label}
                                    </div>
                                </Link>

                                </li>
                            ))}
                            {site?.id == 2146  &&
                                <li className={styles.li_busca} style={{color: cor_fundo3}}>
                                    <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/Studio')} passHref>
                                    <div
                                        className={styles.info_body_cities}
                                        title={`Studio em ${site?.Dados?.cidade} e região`}
                                    >
                                        Studio
                                    </div>
                                </Link>
                                </li>
                            }
                        </ul>
                    </div>
                : null}

                {site?.exibir_empreendimento && validaEmpree && site?.id != 2231 ? (
                    <div className={styles.divisao}>
                        <div className={styles.info_header} style={{color: cor_fundo3}}>
                            {site?.id == 1884 ? `RESIDENCIAIS` : site?.id == 2474 ? `Ofertas em Condomínio` : `EMPREENDIMENTOS`}
                        </div>
                        <ul className={styles.adjust_cities}>
                            {(allRodape1?.filter((value: { empreendimento: any; }) => value?.empreendimento) || []) // Filtra para remover valores nulos ou indefinidos em 'empreendimento'
                                .filter((value: { empreendimento: any; }, index: number, self: any[]) =>
                                    self.findIndex(v => v.empreendimento === value.empreendimento) === index // Remove duplicatas baseadas na propriedade 'empreendimento'
                                )
                                .slice(0, 10) // Limita aos primeiros 10 casos verdadeiros
                                .map((v: any, cont: number) => (
                                    <li className={styles.li_busca} key={cont} style={{color: cor_fundo3}}>
                                        <Link prefetch={false} href={withCodsite(`/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/${removerAcentos(v?.empreendimento).toLowerCase()?.replaceAll("\n", '-')}/-`.replaceAll(
                                            ' ',
                                            '-'
                                        ))} passHref>
                                            <div
                                                title={"Empreendimento " + v?.empreendimento}
                                                key={cont}
                                                className={styles.info_body_cities}
                                            >
                                                {capitalizeWords(v?.empreendimento.toLowerCase())}
                                            </div>
                                        </Link>
                                    </li>
                                ))}
                        </ul>
                    </div>
                ) : null}

                <div className={styles.divisao}>
                    <div className={styles.info_header} style={{color: cor_fundo3}}>INSTITUCIONAL</div>
                    <ul className={styles.adjust_cities}>
                        { site?.transacoes[0] == 'Venda' ?
                            <li className={styles.li_busca} key={"venda"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/-')} title={`Imóveis para venda`} passHref>
                                    <div className={styles.info_body_cities}>
                                        Imóveis para Venda
                                    </div>
                                </Link>
                            </li>
                            : site?.transacoes[0] == 'Aluguel' ?
                            <li className={styles.li_busca} key={"aluguel"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/-')} passHref>
                                    <div title={`Imóveis para locação`} className={styles.info_body_cities}>
                                        Imóveis para Locação
                                    </div>
                                </Link>
                            </li>
                        : null }
                        { site?.transacoes[1] == 'Aluguel' ?
                            <li className={styles.li_busca} key={"aluguel"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/-')} passHref>
                                    <div title={`Imóveis para locação`} className={styles.info_body_cities}>
                                        Imóveis para Locação
                                    </div>
                                </Link>
                            </li>
                        : null }
                        { site?.promocao && site?.id != 2097 ?
                            <li className={styles.li_busca} key={"aluguel"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-?promocao=1')} passHref>
                                    <div  className={styles.info_body_cities}>{isNovember ? "Black November" : site?.id == "1630" ? "Off Market" : "Imóveis em Promoção"}</div>
                                </Link>
                            </li>
                        : null }
                        {site?.id == 2059 ?
                            <li className={styles.li_busca} key={"exclusivos"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite(`/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?categoria=9999`)} passHref>
                                    <div title={`Imóveis Exclusivos`} className={styles.info_body_cities}>
                                        Imóveis Exclusivos
                                    </div>
                                </Link>
                            </li>
                        : null}
                        {allDataHome?.blogs[0]?.id &&
                            <li className={styles.li_busca} key={"blog"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/blog')} passHref>
                                    <div title={`Clique aqui para navegar ao Blog do imobiliária`} className={styles.info_body_cities}>
                                        Blog
                                    </div>
                                </Link>
                            </li>
                        }
                        {site?.promocao ?
                            <li className={styles.li_busca} key={"destaque"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite(`/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?promocao=1`)} passHref>
                                    <div title={`Imóveis em Destaque`} className={styles.info_body_cities}>
                                        {`Imóveis em Destaque`}
                                    </div>
                                </Link>
                            </li>
                        : null}
                        { favorito?.length > 0 ?
                            <li className={styles.li_busca} key={"favoritos"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite(renderText())} passHref>
                                    <div title={`Imóveis Favoritos`} className={styles.info_body_cities}>
                                        Imóveis Favoritos
                                    </div>
                                </Link>
                            </li>
                        : null }
                        { site?.simulador && site?.simulador != undefined ?
                            <li className={styles.li_busca} key={"financiamento"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/?simulador=1')} passHref>
                                    <div title={`Simulador de Financiamento`} className={styles.info_body_cities}>
                                        Simulador de Financiamento
                                    </div>
                                </Link>
                            </li>
                        : null }
                        { site?.simulador && site?.simulador != undefined ?
                            <li className={styles.li_busca} key={"cadastre"} style={{color: cor_fundo3}}>
                                <a title={`Cadastre seu imóvel`} className={styles.info_body_cities}
                                    rel="noopener noreferrer"
                                    href={`https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel1 || site?.Dados?.tel2
                                    )?.replace(/\D/g, '')}&text=Olá, Gostaria de cadastrar meu imóvel no site Link: ${site?.site}`}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel1 || site?.Dados?.tel2
                                    )?.replace(/\D/g, '')}&text=Olá, Gostaria de cadastrar meu imóvel no site Link: ${site?.site}`,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                >
                                    Cadastre seu Imóvel
                                </a>
                            </li>
                        : null }
                        { site?.id == 2059  ?
                            <>
                            <li className={styles.li_busca} key={"financ"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/-?categoria=1')} passHref>
                                    <div title={`Simulador de Financiamento`} className={styles.info_body_cities}>
                                        Lançamentos
                                    </div>
                                </Link>
                            </li>
                            <li className={styles.li_busca} key={"fina"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/-?categoria=10019')} passHref>
                                    <div title={`Simulador de Financiamento`} className={styles.info_body_cities}>
                                        MCMV Pronto
                                    </div>
                                </Link>
                            </li>
                            <li className={styles.li_busca} key={"mento"} style={{color: cor_fundo3}}>
                                <Link prefetch={false} href={withCodsite('/imoveis/venda/-/-/-/-?categoria=659')} passHref>
                                    <div title={`Simulador de Financiamento`} className={styles.info_body_cities}>
                                        Em Obras
                                    </div>
                                </Link>
                            </li>
                            </>
                        : null }
                    </ul>
                </div>
                {site?.id == 2059 &&
                    <div className={styles.divisao}>
                    <div className={styles.info_header} style={{color: cor_fundo3}}>LOCAÇÃO</div>
                    <ul className={styles.adjust_cities}>
                        <li className={styles.li_busca} key={"apartamentos"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/apartamento')} passHref>
                                <div title={`Apartamentos para alugar`} className={styles.info_body_cities}>
                                    Apartamento para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"para_alugar"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/apartamento?categoria=3')} passHref>
                                <div title={`Apartamentos para alugar`} className={styles.info_body_cities}>
                                    Apartamento Mobiliadol para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"sala_comercial"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/sala-comercial')} passHref>
                                <div title={`Sala Comercial para alugar`} className={styles.info_body_cities}>
                                    Sala Comercial para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"cobertura1"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/cobertura')} passHref>
                                <div title={`Coberturas para alugar`} className={styles.info_body_cities}>
                                    Cobertura para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"galpao"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/galpao')} passHref>
                                <div title={`Galpão para alugar`} className={styles.info_body_cities}>
                                    Galpão para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"casa_comercial"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/casa-comercial')} passHref>
                                <div title={`Casa Comercial para alugar`} className={styles.info_body_cities}>
                                Casa Comercial para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"sobrado"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/sobrado')} passHref>
                                <div title={`Sobrado para alugar`} className={styles.info_body_cities}>
                                Sobrado para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"cobertura2"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/cobertura')} passHref>
                                <div title={`Cobertura para alugar`} className={styles.info_body_cities}>
                                Cobertura para aluguel
                                </div>
                            </Link>
                        </li>
                        <li className={styles.li_busca} key={"baixo_condo"} style={{color: cor_fundo3}}>
                            <Link prefetch={false} href={withCodsite('/imoveis/aluguel/-/-/-/apartamento-baixo-condominio')} passHref>
                                <div title={`Apartamento baixo condomínio para alugar`} className={styles.info_body_cities}>
                                Apartamento baixo condomínio
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>
                }
            </div>
            }
            <div
                className={styles.container}
                style={{ backgroundColor: site?.cor6 }}
            >
                <div className={styles.divisao1}>
                    {site?.id == 2243 ?
                        <div className={styles.rodapeImg}>
                            <Image
                                src={"https://fotos.sobressai.com.br/Banner/2243/11342.jpg"}
                                alt={`Imobiliária ${site?.Dados?.empresa}`}
                                title={`Imobiliária ${site?.Dados?.empresa}`}
                                className={styles.logo_welcome}
                                width={200}
                                height={150}
                            />
                        </div>
                    :null}
                   <div className={`${styles.rodapeImg} ${showLoftBadge ? styles.footerLogoBadgeContainer : ''}`}>
  {site?.url_logo && !isMobile ? (
    <Link prefetch={false} href={withCodsite('/')} passHref>
      <div title={`Imobiliária ${site?.Dados?.empresa}`}>
        <Image
          src={
            site?.id == "2434"
              ? "https://imob.sobressai.com.br/Banner/2434/11945.jpg"
              : site?.id == "2449"
              ? "https://imob.sobressai.com.br/Banner/2449/12082.jpg"
              : site?.id == "2502"
              ? "https://imob.sobressai.com.br/Banner/2502/12183.jpg"
              : site?.id == "2257"
              ? "https://fotos.sobressai.com.br/Banner/2257/11442.jpg"
              : site?.id == "2483"
              ? "https://imob.sobressai.com.br/Banner/2483/12056.jpg"
              : site?.id == "2245"
              ? "https://fotos.sobressai.com.br/Banner/2245/11400.jpg"
              : site?.id == "2190"
              ? "https://fotos.sobressai.com.br/cdn-cgi/image/format=auto,height=550px,width=840px,quality=100/https://fotos.sobressai.com.br/Fotos/Logos/2190.png"
              : site?.id == "2362"
              ? "https://fotos2.fra1.cdn.digitaloceanspaces.com/logo_2362.png"
              : site?.id == "2400"
              ? "https://fotos.sobressai.com.br/Fotos/Logos/logo_rodape_2400.png"
              : site?.id == "2112"
              ? "https://fotos.sobressai.com.br/Banner/2112/11067.jpg"
              : `${site?.url_logo}?v=${site?.contador_marca || 0}`
          }
          alt={`Imobiliária ${site?.Dados?.empresa}`}
          title={`Imobiliária ${site?.Dados?.empresa}`}
          className={styles.logo_welcome}
          height={
            site?.id == "2127" || site?.id == "2216" || site?.id == "2190"
              ? 200
              : site?.id == "1630"
              ? 100
              : 150
          }
          width={site?.id == "2098" ? 400 : 300}
          style={
            site?.id == "1630" || site?.id == "2346"
              ? {
                  height: "100px",
                  width: "auto",
                  objectPosition: "left center",
                  padding: "0px",
                }
              : {}
          }
        />
      </div>
    </Link>
  ) : null}
  {showLoftBadge ? (
    <div
      id="loft-badge"
      data-agency-id="35202722000103"
      style={{ width: 100, height: 100 }}
    />
  ) : null}
</div>
                    {site?.id != "2098" && site?.id != "2348" && site?.id != "2239" && site?.id != "2243" && site?.id != "2346" &&
                        <div className={styles.info_header} style={site?.id == 2364 ? {color: "#7b803c"} : {color: cor_fundo6,textAlign: "center"}}>
                            {site?.Dados?.empresa.toUpperCase()}
                        </div>
                    }
                    { site?.id == 2185 &&
                        <div style={{color: cor_fundo6}}>
                            <b>CNPJ 28.715.104/0001-00</b><br /><br />

                            <b>Somos apaixonados em proporcionar encontros. Somos A GP Imobiliária! Uma</b><br />

                            <b>empresa que desde 2008 está ao seu lado em busca das melhores</b><br />

                            <b>oportunidades no mercado imobiliário na locação e venda de imóveis.</b><br /><br />
                        </div>
                    }
                    { site?.Dados?.endereco && site?.id != 2157 && site?.id != 2251 &&
                        <div className={styles.info_body_not_hover} style={site?.id == 2364 ? {color: "#7b803c"} : {color: cor_fundo6}}>
                            {site?.Dados?.endereco && `${site?.Dados?.endereco} - `}
                            {site?.Dados?.bairro && site?.Dados?.cidade && `${site?.Dados?.bairro} - ${site?.Dados?.cidade}`}
                            { site?.id != '1866' ?
                                <>
                                    {` - `}
                                    <a
                                        target="_blank" rel="noreferrer"
                                        href={site?.url_maps ? site?.url_maps : `https://www.google.com/maps/dir//${(site?.Dados?.endereco ? site?.Dados?.endereco+"-" : '')+(site?.Dados?.bairro+"-"+site?.Dados?.cidade)}`}
                                        style={site?.id == 2364 ? {color: "#7b803c"} : {color: cor_fundo6}}
                                        title='Ver localização da imobiliária no Google Maps'
                                        className={styles.abrir_mapa}
                                        >

                                        <svg
                                            viewBox="0 -10 100 100"
                                            height="16px"
                                            width="16px"
                                            aria-hidden="true"
                                            focusable="false"
                                            fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="StyledIconBase-ea9ulj-0 fHrGFt"
                                        >
                                            <path d="M50 10.417c-15.581 0-28.201 12.627-28.201 28.201a28.074 28.074 0 005.602 16.873L45.49 86.823c.105.202.21.403.339.588l.04.069.011-.006a5.063 5.063 0 004.135 2.111c1.556 0 2.912-.708 3.845-1.799l.047.027.179-.31c.264-.356.498-.736.667-1.155L72.475 55.65a28.074 28.074 0 005.726-17.032c0-15.574-12.62-28.201-28.201-28.201zm-.279 42.498c-7.677 0-13.895-6.221-13.895-13.895 0-7.673 6.218-13.895 13.895-13.895s13.895 6.222 13.895 13.895c0 7.673-6.218 13.895-13.895 13.895z"></path>
                                        </svg>
                                        Abrir mapa
                                    </a>
                                </>
                        : null }
                        </div>
                    }
                    { site?.id == 2504 &&
                        <>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Ipanema: Rua Maria Quitéria 77- Loja 217 - Ipanema - Rio de Janeiro
                            </div>
                        </>
                    }
                    { site?.id == 2444 &&
                        <>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Rua Dr. Gregório Costa, Nº 237, Sala 305, 3° Andar, Centro, Edifício Smart Office, Pindamonhangaba. (Atendimento com hora marcada)
                            </div>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Av. Itália, Nº 928, Sala 1603, 16° Andar, Jardim das Nações, Edifício The One Office Tower, Taubaté. (Atendimento com hora marcada)
                            </div>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Av. Cassiano Ricardo, Nº 601, Sala 163, 16° Andar, Jardim Aquarius, Edifício The One Office Tower, São José dos Campos. (Atendimento com hora marcada)
                            </div>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Rua Padre Américo Virgílio Andrizzi, nº 21, Sala 2, Centro - Caraguatatuba. (Atendimento com hora marcada)
                            </div>
                        </>
                    }
                    { site?.id == 2251 &&
                        <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                            Alamedas Imóveis Ltda
                            <br></br>
                            CNPJ 55.174.606/00001-35
                            <br></br>
                            <br></br>
                            <br></br>Rua Pamplona, 1465 Cj 21 - Jd. Paulista - SP
                            <br></br>
                        </div>
                    }
                    { site?.id == 2463 &&
                        <div className={styles.info_body_not_hover} style={{color: cor_fundo6,marginTop: 15}}>
                            Rua Chapot Presvot, 250, Praia do Canto, Vitória/ES
                            <>
                                {` - `}
                                <a
                                    target="_blank" rel="noreferrer"
                                    href="https://www.google.com/maps/place/R.+Chapot+Presvot,+250+-+Praia+do+Canto,+Vitória+-+ES,+29055-410/data=!4m2!3m1!1s0xb817e94e98b5ed:0x24853bfab8f64f95?sa=X&ved=1t:242&ictx=111"
                                    style={{color: cor_fundo6}}
                                    title='Ver localização da imobiliária no Google Maps'
                                    className={styles.abrir_mapa}
                                    >

                                    <svg
                                        viewBox="0 -10 100 100"
                                        height="16px"
                                        width="16px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path d="M50 10.417c-15.581 0-28.201 12.627-28.201 28.201a28.074 28.074 0 005.602 16.873L45.49 86.823c.105.202.21.403.339.588l.04.069.011-.006a5.063 5.063 0 004.135 2.111c1.556 0 2.912-.708 3.845-1.799l.047.027.179-.31c.264-.356.498-.736.667-1.155L72.475 55.65a28.074 28.074 0 005.726-17.032c0-15.574-12.62-28.201-28.201-28.201zm-.279 42.498c-7.677 0-13.895-6.221-13.895-13.895 0-7.673 6.218-13.895 13.895-13.895s13.895 6.222 13.895 13.895c0 7.673-6.218 13.895-13.895 13.895z"></path>
                                    </svg>
                                    Abrir mapa
                                </a>
                            </>
                            <br /><br />

                            Rua Humberto de Campos, 450, Parque Residencial Laranjeiras, Serra/ES
                            <>
                                {` - `}
                                <a
                                    target="_blank" rel="noreferrer"
                                    href="https://www.google.com/maps/place/R.+Humberto+de+Campos,+450+-+Parque+Res.+Laranjeiras,+Serra+-+ES,+29165-410/@-20.1986054,-40.2501496,17z/data=!3m1!4b1!4m6!3m5!1s0xb81ec1b5291549:0x49c1395da870f93!8m2!3d-20.1986054!4d-40.2501496!16s%2Fg%2F11nntq26y2?entry=ttu&g_ep=EgoyMDI1MTEwMi4wIKXMDSoASAFQAw%3D%3D"
                                    style={{color: cor_fundo6}}
                                    title='Ver localização da imobiliária no Google Maps'
                                    className={styles.abrir_mapa}
                                    >

                                    <svg
                                        viewBox="0 -10 100 100"
                                        height="16px"
                                        width="16px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path d="M50 10.417c-15.581 0-28.201 12.627-28.201 28.201a28.074 28.074 0 005.602 16.873L45.49 86.823c.105.202.21.403.339.588l.04.069.011-.006a5.063 5.063 0 004.135 2.111c1.556 0 2.912-.708 3.845-1.799l.047.027.179-.31c.264-.356.498-.736.667-1.155L72.475 55.65a28.074 28.074 0 005.726-17.032c0-15.574-12.62-28.201-28.201-28.201zm-.279 42.498c-7.677 0-13.895-6.221-13.895-13.895 0-7.673 6.218-13.895 13.895-13.895s13.895 6.222 13.895 13.895c0 7.673-6.218 13.895-13.895 13.895z"></path>
                                    </svg>
                                    Abrir mapa
                                </a>
                            </>
                            <br /><br />
                        </div>
                    }
                    { site?.id == 2137 &&
                        <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                            <b>Novo Hamburgo</b><br />
                            Rua Joaquim Pedro Soares, nº 1.220, Bairro Guarani - CEP: 93520-600 – RS
                            <br /><br />

                            <b>São Leopoldo</b><br />
                            Rua São Paulo, 488, Bairro Centro
                            <br /><br />

                            <b>Canoas</b><br />
                            Rua Guarujá, 1314 – Bairro São José
                            <br /><br />

                            <b>Porto Alegre</b><br />
                            Avenida Assis Brasil, 4562, Loja 15
                            <br /><br />
                        </div>
                    }

                    { site?.id == 1652 &&
                        <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                           CNPJ: 32.491.153/0001-75
                            <br /><br />
                        </div>
                    }

                    { site?.id == 2194 &&
                        <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                            R. Iara Teodoro da Silva, 399 - Veneza, Ribeirão das Neves - MG, 30820-010
                            <a
                                target="_blank" rel="noreferrer"
                                href={`https://www.google.com/maps/place/R.+Iara+Teodoro+da+Silva,+399+-+Veneza,+Ribeir%C3%A3o+das+Neves+-+MG,+33820-010/@-19.7708796,-44.130423,17z/data=!3m1!4b1!4m6!3m5!1s0xa6f286c803b51b:0x594a856e2f7b4a24!8m2!3d-19.7708796!4d-44.130423!16s%2Fg%2F11fz9zzzxt?entry=ttu&g_ep=EgoyMDI0MTAyNy4wIKXMDSoASAFQAw%3D%3D`}
                                style={{color: cor_fundo6}}
                                title='Ver localização da imobiliária no Google Maps'
                                className={styles.abrir_mapa}
                                >
                                {` - `}
                                <svg
                                    viewBox="0 -10 100 100"
                                    height="16px"
                                    width="16px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                >
                                    <path d="M50 10.417c-15.581 0-28.201 12.627-28.201 28.201a28.074 28.074 0 005.602 16.873L45.49 86.823c.105.202.21.403.339.588l.04.069.011-.006a5.063 5.063 0 004.135 2.111c1.556 0 2.912-.708 3.845-1.799l.047.027.179-.31c.264-.356.498-.736.667-1.155L72.475 55.65a28.074 28.074 0 005.726-17.032c0-15.574-12.62-28.201-28.201-28.201zm-.279 42.498c-7.677 0-13.895-6.221-13.895-13.895 0-7.673 6.218-13.895 13.895-13.895s13.895 6.222 13.895 13.895c0 7.673-6.218 13.895-13.895 13.895z"></path>
                                </svg>
                                Abrir mapa
                            </a>
                        </div>
                    }
                    {site?.Dados?.tel1 && site?.id != 1946 && site?.id != 2297 && site?.id != 2243 ?
                        <a
                            className={styles.info_body}
                            title='Entrar em contato com a imobiliária tel 1'
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                            site?.Dados?.tel1
                                        )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}
                        >
                            {site?.id == 2098 ?
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 1"
                                    title={'Icone WhatsApp 1'}
                                    src={IconWhatsapp}
                                />
                            : site?.Dados?.tel1_whats ? <svg
                                viewBox="0 0 16 16"
                                height="24px"
                                width="24px"
                                aria-hidden="true"
                                focusable="false"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                            >
                                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                            </svg> : null}

                            <div className={styles.margin_text} style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}>
                                {`${
                                    site?.Dados?.tel1 + (site?.Dados?.tel1_nome ? " - "+site?.Dados?.tel1_nome : "")
                                }`}
                            </div>
                        </a>
                    :null}
                    {site?.Dados?.tel2 && site?.id != "1946" ?
                        <a
                            className={styles.info_body}
                            title='Entrar em contato com a imobiliária tel 2'
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel2
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel2
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel2
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel2
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}
                        >
                            {site?.id == 2098 ?
                                <Image
                                    height={24}
                                    width={24}
                                    alt="Icon Contato 1"
                                    title={'Icone WhatsApp 2'}
                                    src={IconWhatsapp}
                                />
                            :
                            site?.Dados?.tel2_whats ? <svg
                                viewBox="0 0 16 16"
                                height="24px"
                                width="24px"
                                aria-hidden="true"
                                focusable="false"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                            >
                                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                            </svg> : null}
                            <div className={styles.margin_text} style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}>
                                {`${
                                    site?.Dados?.tel2 + (site?.Dados?.tel2_nome ? " - "+site?.Dados?.tel2_nome : "")
                                }`}
                            </div>
                        </a>
                    :null}
                    {site?.Dados?.tel3 && site?.id != "1946" ?
                        <a
                            title='Entrar em contato com a imobiliária tel 3'
                            className={styles.info_body}
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel3
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel3
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel3
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel3
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}
                        >
                            {site?.Dados?.tel3_whats ? <svg
                                viewBox="0 0 16 16"
                                height="24px"
                                width="24px"
                                aria-hidden="true"
                                focusable="false"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                            >
                                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                            </svg> : null}
                            <div className={styles.margin_text} style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}>
                                {`${
                                    site?.Dados?.tel3 + (site?.Dados?.tel3_nome ? " - "+site?.Dados?.tel3_nome : "")
                                }`}
                            </div>
                        </a>
                    :null}
                    {site?.Dados?.tel4 && site?.id != "1946" ?
                        <a
                            className={styles.info_body}
                            title='Entrar em contato com a imobiliária tel 4'
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel4
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel4
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel4
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel4
                                    )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            style={{color: cor_fundo6}}
                        >
                            {site?.Dados?.tel4_whats ? <svg
                                viewBox="0 0 16 16"
                                height="24px"
                                width="24px"
                                aria-hidden="true"
                                focusable="false"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                            >
                                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                            </svg> : null}
                            <div className={styles.margin_text} style={{color: cor_fundo6}}>
                                {`${
                                    site?.Dados?.tel4 + (site?.Dados?.tel4_nome ? " - "+site?.Dados?.tel4_nome : "")
                                }`}
                            </div>
                        </a>
                    :null}
                    {site?.id != "1739" && site?.id != "2243" && (
                        site?.id == 1535 || site?.id == 2551 || site?.Dados?.email1 || site?.Dados?.email2
                    ) ? (
                        <>
                            <div
                                className={styles.info_body_not_hover}
                                style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}
                            >
                                {site?.id == 1535
                                    ? "Email: diegodeavila1985@gmail.com"
                                    : site?.id == 2551
                                    ? `Email: ${site?.Dados?.email1 || site?.Dados?.email2}`
                                    : site?.id == 2239
                                    ? `${site?.Dados?.email1 || site?.Dados?.email2}`
                                    : `Email: ${site?.Dados?.email1 || site?.Dados?.email2}`}
                                {site?.Dados?.creci && site?.id == 2153 && ` - Creci: ${site?.Dados?.creci}`}
                            </div>
                            {site?.id == 2551 ? (
                                <div
                                    className={styles.info_body_not_hover}
                                    style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}
                                >
                                    Email: aluguel@hachbart.com.br
                                </div>
                            ) : null}
                        </>
                    ) : null}
                    {site?.Dados?.horario ?
                        <div className={styles.info_body_not_hover} style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}>
                            {site?.id == 1801 || site?.id == 2237 ? `${
                                site?.Dados?.horario
                            }` : `Horário de Atendimento: ${
                                site?.Dados?.horario
                            }`}
                        </div>
                    : null}
                    {site?.id == 1673 ?
                        <div className={styles.creci} style={{color: cor_fundo6,marginBottom: 0}}>
                            CNPJ: 00.866.575/0001-91
                        </div>
                    : null}
                    {site?.id == 2257 ?
                        <div className={styles.creci} style={{color: cor_fundo6,marginBottom: 0}}>
                            CNPJ: 58.409.058/0001-73
                        </div>
                    : null}
                    {site?.id == 2141 ?
                        <div className={styles.creci} style={{color: cor_fundo6,marginBottom: 0}}>
                            CNPJ: 49.817.311/0001-37
                        </div>
                    : null}
                    {site?.id == 2168 ?
                        <div className={styles.creci} style={{color: cor_fundo6,marginBottom: 0}}>
                            CNPJ: 56.171.086/0001-70
                        </div>
                    : null}
                    {site?.id == 2312 ?
                        <>
                            <div className={styles.creci} style={{color: cor_fundo6,marginBottom: 0}}>
                                CRECI-CE 27.172 J
                            </div>
                            <div className={styles.creci} style={{color: cor_fundo6,marginBottom: 0}}>
                                CNPJ: 59.709.705/0001-25
                            </div>
                        </>
                    : null}
                    {site?.Dados?.creci && site?.id != 2153 && site?.id != 2251 && site?.id != 1924 && site?.id != 2260 && site?.id != 2297 ?
                        <div className={styles.creci} style={site?.id == 2364 ? {color: "#7b803c"} :{color: cor_fundo6}}>
                            {`CRECI ${site?.Dados?.creci}`}
                        </div>
                    : null}
                    {site?.html_rodape ?
                        <div className={styles.creci} style={{color: cor_fundo6}}
                            dangerouslySetInnerHTML={{
                                __html: site?.html_rodape,
                            }}>
                        </div>
                    : null}
                    {site?.id == 2236 ?
                        <div className={styles.creci} style={{color: cor_fundo6}}>
                            CNAI 24.873
                        </div>
                    : null}
                    {site?.id == 2492 ?
                        <div className={styles.creci} style={{color: cor_fundo6}}>
                            CRECI 79142
                        </div>
                    : null}
                    {site?.id == 2297 ?
                        <>
                            <div className={styles.creci} style={{color: cor_fundo6}}>
                                CRECI 78207F
                            </div>
                            <div className={styles.info_header} style={{color: cor_fundo6,textAlign: "center"}}>
                                IMÓVEIS DEFERRARI SC
                            </div>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Rua Anita Garibaldi 271
                                Centro de Criciúma SC
                            </div>
                            <div className={styles.info_body_not_hover} style={{color: cor_fundo6}}>
                                Email: contato.sc@imoveisdeferrari.com.br
                            </div>
                            {site?.Dados?.tel1 ?
                                <a
                                    className={styles.info_body}
                                    title='Entrar em contato com a imobiliária tel 1'
                                    rel="noopener noreferrer"
                                    href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                                site?.Dados?.tel1
                                                )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                                    site?.Dados?.tel1
                                                )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                                site?.Dados?.tel1
                                                )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?` : `https://api.whatsapp.com/send?phone=55${(
                                                    site?.Dados?.tel1
                                                )?.replace(/\D/g, '')}&text=Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    style={{color: cor_fundo6}}
                                >
                                    {site?.id == 2098 ?
                                        <Image
                                            height={24}
                                            width={24}
                                            alt="Icon Contato 1"
                                            title={'Icone WhatsApp 1'}
                                            src={IconWhatsapp}
                                        />
                                    : site?.Dados?.tel1_whats ? <svg
                                        viewBox="0 0 16 16"
                                        height="24px"
                                        width="24px"
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    >
                                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                    </svg> : null}

                                    <div className={styles.margin_text} style={{color: cor_fundo6}}>
                                        {`${
                                            site?.Dados?.tel1 + (site?.Dados?.tel1_nome ? " - "+site?.Dados?.tel1_nome : "")
                                        }`}
                                    </div>
                                </a>
                            :null}
                            <div className={styles.creci} style={{color: cor_fundo6}}>
                                CRECI 10336J
                            </div>
                        </>
                    : null}
                    {site?.id == 2260 ?
                        <div className={styles.creci} style={{color: cor_fundo6}}>
                            CRECI/MGF 59.615
                        </div>
                    : null}
                    {site?.id == 2183 ?
                        <div className={styles.creci} style={{color: cor_fundo6}}>
                            CRECI 67.839/SC
                        </div>
                    : null}
                    {site?.id == 1924 ?
                        <div className={styles.creci} style={{color: cor_fundo6}}>
                            Sabrina 210251F
                            <br></br>
                            Alessandra 253745F
                        </div>
                    : null}
                    {site?.id == 1630 ? (
                        <div className={styles.footerFlags}>
                            {footerFlags.map((flag) => (
                                <Image
                                    key={flag.code}
                                    src={`https://flagcdn.com/w20/${flag.code}.png`}
                                    alt={`Bandeira ${flag.label}`}
                                    width={20}
                                    height={15}
                                    className={styles.footerFlag}
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
            {site?.copyright ?
                <div className={styles.texto_div}>
                   {site?.texto_rodape ? (
                        <h4 className={styles.texto_rodape}>
                            {site?.texto_rodape}
                        </h4>
                    ) : Number(site?.id) === 1714 ? (
                        <h4 className={styles.texto_rodape}>
                            Imóveis à venda em Arambaré e região da Lagoa dos Patos: fazendas, sítios, terrenos e casas com a Busch Terras & Fazendas.
                        </h4>
                    ) : site?.Dados?.empresa && site?.Dados?.cidade && Number(site?.id) !== 2157 ? (
                        <h4 className={styles.texto_rodape}>
                            {`Buscando imóveis à venda em ${site?.Dados?.cidade}? A ${site?.Dados?.empresa} oferece uma seleção exclusiva de casas e apartamentos. Descubra seu novo lar conosco!`}
                        </h4>
                    ) : null}
                    <div className={styles.rodapeImgCopy}>
                        <a
                            className={styles.copyright}
                            href={`https://www.imobtotal.com.br/lp/site-imobiliaria?utm_source=sitedeclientes&utm_medium=modelosnovos&utm_campaign=%23${host}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Image src={'https://imob.sobressai.com.br/importacoes/import_xml/xml/logo/logo_nova_1.png'} alt="CRM Imobiliário" width={200} height={25} style={{objectFit: 'contain'}}></Image>
                        </a>
                    </div>
                </div>
            : null}
            {showLoftBadge ? (
                <Script
                    id="loft-badge-script-1898"
                    defer
                    type="module"
                    src="https://loft-badge.loft.com.br/index.js"
                />
            ) : null}
        </>
    );
};

export default AboutPieces1;
